"use client";

import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Advisory() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".advisory-card", {
        y: 16
      });
      gsap.to(".advisory-card", {
        opacity: 1,
        y: 0,
        duration: 0.45,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(".advisory-card", {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section ref={container} id="usedcontrolleradvisory" data-nav="light" className="bg-background py-16 sm:py-20 lg:py-24 border-b border-border">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="advisory-card bg-card text-card-foreground border border-border p-6 sm:p-8 lg:p-12" style={{
        opacity: 0
      }}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold uppercase tracking-tight text-foreground leading-[1.05] mb-6 sm:mb-8">
            Ask About the Controller Before Buying Used
          </h2>

          <div className="space-y-4 sm:space-y-6 text-foreground text-base sm:text-lg leading-relaxed">
            <p>
              The controller deserves particular attention on a pre-owned machine. Different systems may use different operating controls, motion settings and emergency-stop arrangements. Replacement controllers may also differ in availability and compatibility.
            </p>

            <p>
              Before buying, confirm which controller is included with the exact machine. Where information is available, review the controller model, visible condition, available functions, known repairs and parts availability.
            </p>

            <div className="border-l-2 border-primary pl-4 sm:pl-5 py-1">
              <p className="font-medium text-foreground">
                Do not assume another controller can simply be substituted without confirming compatibility.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}